/**
 * Open a link that arrives AFTER the click — an API that mints a short-lived
 * URL per open (an invoice document: Stripe's links expire, so none is stored).
 *
 * A pop-up blocker allows a window opened inside the click, not one opened
 * when a request settles. So the tab opens now, blank, and is pointed at the
 * URL when it arrives; if the URL cannot be had, the tab closes and the error
 * is the caller's to show. Shared by every portal that opens such a link.
 */
export async function openInNewTabWhenReady(resolveUrl: () => Promise<string>): Promise<void> {
  const tab = window.open('', '_blank');
  try {
    const url = await resolveUrl();
    if (tab) {
      // The link is third-party (Stripe): it must not reach back into the app.
      tab.opener = null;
      tab.location.href = url;
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  } catch (err) {
    tab?.close();
    throw err;
  }
}
